import {RemotePostBeneficiaryAddressV4} from 'data/usecases';
import {PostBeneficiaryAddressV4} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makePostBeneficiaryAddressV4 = (): PostBeneficiaryAddressV4 =>
	new RemotePostBeneficiaryAddressV4(
		makeBFFApiUrl(ProfileChangeDataEndpoints.beneficiaryAddressV4),
		makeAuthorizeHttpClientDecorator(),
	);
